import Vue from 'vue'
import VueRouter from 'vue-router'
import ApiHandler from '@/ApiHandler'
import DashboardSelect from '@/components/dashboards/dashboardselect.vue'
import Login from '@/components/Login.vue'
import Home from '@/components/cms/home.vue'
import About from '@/components/cms/about.vue'
import Contact from '@/components/cms/contact.vue'
import ProjectDashboard from '@/components/dashboards/ProjectDashboard.vue'
import AppMeldingDashboard from '@/components/dashboards/AppMeldingDashboard.vue'
import Beheer from '@/components/administration/switchboardadmin.vue'
import BeheerGebruikers from '@/components/administration/gebruikers.vue'
import BeheerGebruiker from '@/components/administration/gebruiker.vue'
import BeheerProfielen from '@/components/administration/profielen.vue'
import BeheerProfiel from '@/components/administration/profiel.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { auth: false }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: { auth: false }
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: { auth: false }
  },
  {
    path: '/app/dashboard/project',
    name: 'projectdashboard',
    component: ProjectDashboard,
    meta: { auth: true }
  },
  {
    path: '/app',
    name: 'dashboardselect',
    component: DashboardSelect,
    meta: { auth: true }
  },
  {
    path: '/app/dashboard/appmeldingen',
    name: 'appmeldingdashboard',
    component: AppMeldingDashboard,
    meta: { auth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: { auth: false }
  },
  {
    path: '/beheer',
    name: 'beheer',
    component: Beheer,
    meta: { auth: true }
  },
  {
    path: '/beheer/gebruikers',
    name: 'beheergebruikers',
    component: BeheerGebruikers,
    meta: { auth: true }
  },
  {
    path: '/beheer/gebruiker/bewerken/:id',
    name: 'beheergebruiker',
    component: BeheerGebruiker,
    meta: { auth: true }
  },
  {
    path: '/beheer/gebruiker/nieuw',
    name: 'newgebruiker',
    component: BeheerGebruiker,
    meta: { auth: true }
  },
  {
    path: '/beheer/profielen',
    name: 'beheerprofielen',
    component: BeheerProfielen,
    meta: { auth: true }
  },
  {
    path: '/beheer/profiel/bewerken/:id',
    name: 'beheerprofiel',
    component: BeheerProfiel,
    meta: { auth: true }
  },
  {
    path: '/beheer/profiel/nieuw',
    name: 'newprofiel',
    component: BeheerProfiel,
    meta: { auth: true }
  },
  /*{
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/About.vue')
  }*/
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
    
  if (to.matched.some(record => record.meta.auth)) {
    // Authenticatie vereist. Check of session-cookie nog geldig is.
    var auth = false;
    (new ApiHandler()).Authenticated() // Vraag server of sessie-id nog geldig is.
      .then((response) => {
        auth = (response.data.length > 0);
        if (auth)
          next(); // Sessie-id is nog geldig
        else
          next({ name: 'login', query: { ReturnUrl: to.fullPath } }); // Sessie-id is verlopen => inlogscherm
      })
      .catch(() => {
        next({ name: 'login', query: { ReturnUrl: to.fullPath } });
      });
  }
  else {
    next();
  }
});

export default router
